import { render, staticRenderFns } from "./objective.vue?vue&type=template&id=6add965d&"
import script from "./objective.vue?vue&type=script&lang=js&"
export * from "./objective.vue?vue&type=script&lang=js&"
import style0 from "./objective.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports